import { useSearchParams } from "react-router-dom";

const MODULE_STATUS_PARAM = "moduleStatus";

export type ModuleStatusFilter = "all" | "active" | "inactive";

export const useModuleStatusFilterSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const moduleStatus = (searchParams.get(MODULE_STATUS_PARAM) as ModuleStatusFilter) || "all";

  const setModuleStatus = (value: ModuleStatusFilter) => {
    const newParams = new URLSearchParams(searchParams);
    if (value === "all") {
      newParams.delete(MODULE_STATUS_PARAM);
    } else {
      newParams.set(MODULE_STATUS_PARAM, value);
    }
    setSearchParams(newParams);
  };

  return { moduleStatus, setModuleStatus };
};
